import { Component, ojs, app, state, v } from "modular-openscriptjs";
import { inform, consoleErrorOnLocal } from "../../../helpers";
import { api } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";

const h = app("h");
const router = app("router");

ojs(SolidIcon);

export default class AcceptInvitation extends Component {
  token = null;
  loading = state(true);
  invitation = state(null);
  error = state(null);

  render() {
    const params = new URLSearchParams(window.location.search);
    this.token = params.get("token");

    if (!this.token) {
      return h.div({ class: "container py-5 text-center py-md-5" }, 
        h.h2({ class: "text-danger" }, "Invalid invitation link.")
      );
    }

    if (this.loading.value) {
      this.fetchInvitation();
    }

    return h.div(
      { class: "min-vh-100 d-flex align-items-center justify-content-center bg-light" },
      h.div(
        { class: "card border-0 shadow-lg rounded-4 p-4", style: "max-width: 450px; width: 100%;" },
        v(this.loading, (l) => {
          if (l.value) return h.div({ class: "text-center py-5" }, h.Spinner());

          return v(this.error, (e) => {
            if (e.value) {
              return h.div(
                { class: "text-center py-4" },
                h.div({ class: "text-danger mb-3" }, h.i({ class: "bi bi-exclamation-circle fs-1" })),
                h.h4({ class: "fw-bold" }, "Invitation Error"),
                h.p({ class: "text-muted" }, e.value),
                h.button({ class: "btn btn-primary rounded-pill w-100 mt-3", onclick: () => router.to("home") }, "Go Home")
              );
            }

            return v(this.invitation, (inv) => {
              if (!inv.value) return null;

              return h.div(
                { class: "text-center" },
                h.div({ class: "bg-primary-subtle text-primary circle mx-auto mb-4 p-3", style: "width: 80px; height: 80px;" }, 
                  h.i({ class: "bi bi-building fs-1" })
                ),
                h.h4({ class: "fw-bold mb-2" }, "You've been invited!"),
                h.p({ class: "text-muted mb-4" }, 
                  "You have been invited to join ", 
                  h.span({ class: "fw-bold text-dark" }, inv.value.branch_name), 
                  " as a ", 
                  h.span({ class: "badge bg-primary-subtle text-primary rounded-pill" }, inv.value.role)
                ),
                h.button(
                  { 
                    class: "btn btn-primary rounded-pill w-100 py-3 fw-bold mb-3 shadow-sm",
                    onclick: this.method("accept")
                  }, 
                  "Accept Invitation"
                ),
                h.button(
                  { 
                    class: "btn btn-link text-muted",
                    onclick: () => router.to("home")
                  }, 
                  "Decline"
                )
              );
            });
          });
        })
      )
    );
  }

  async fetchInvitation() {
    try {
      // We might need a public endpoint to peek at the invitation details
      const res = await api.get(`invitations/peek?token=${this.token}`);
      if (res) {
        this.invitation.value = res.data.invitation;
      }
    } catch (e) {
      this.error.value = e.response?.data?.message || "Failed to load invitation details.";
    } finally {
      this.loading.value = false;
    }
  }

  async accept() {
    try {
      const res = await api.post("invitations/accept", { token: this.token });
      if (res) {
        inform(res.data.message, "success");
        // Redirect to branch management or home
        router.to("home");
      }
    } catch (e) {
      inform(e.response?.data?.message || "Failed to accept invitation", "error");
    }
  }
}

ojs(AcceptInvitation);
